export const filterBoardCards = (cards, { search = "", labelId = "", assigneeId = "", dueFilter = "" }) => {
  const q = search.trim().toLowerCase();
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const weekEnd = new Date(today);
  weekEnd.setDate(weekEnd.getDate() + 7);

  return cards.filter((card) => {
    if (q && !card.title.toLowerCase().includes(q) && !String(card.description || "").toLowerCase().includes(q)) {
      return false;
    }
    if (labelId && !(card.labelIds || []).includes(labelId)) return false;
    if (assigneeId && !(card.assigneeIds || []).includes(Number(assigneeId))) return false;

    if (dueFilter === "none" && card.dueDate) return false;
    if (dueFilter && dueFilter !== "none" && card.dueDate) {
      const due = new Date(card.dueDate);
      const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate());
      if (dueFilter === "overdue" && dueDay >= today) return false;
      if (dueFilter === "today" && dueDay.getTime() !== today.getTime()) return false;
      if (dueFilter === "week" && (dueDay < today || dueDay > weekEnd)) return false;
    }
    if (dueFilter && dueFilter !== "none" && !card.dueDate) return false;

    return true;
  });
};
